import { render, staticRenderFns } from "./UpscaleJobTile.vue?vue&type=template&id=20a0a137&scoped=true"
import script from "./UpscaleJobTile.vue?vue&type=script&lang=js"
export * from "./UpscaleJobTile.vue?vue&type=script&lang=js"
import style0 from "./UpscaleJobTile.vue?vue&type=style&index=0&id=20a0a137&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a0a137",
  null
  
)

export default component.exports